import { ErrorMessage, useFormikContext } from 'formik'
import React, { useEffect } from 'react'

function InputFieldOutlined({
  label,
  name,
  placeholder,
  type,
  readOnly,
  required,
  StartIcon,
  EndIcon,
  value,
  onChange,
  autoFocus,
  Ref,
  labelClass = '',
  inputClass = '',
}) {
  const formik = useFormikContext()
  const props = name ? formik?.getFieldProps(name) : {}

  useEffect(() => {
    const inputField = document.getElementById(name)

    const preventScroll = (event) => {
      if (inputField && inputField.type === 'number') {
        event.preventDefault()
      }
    }

    if (inputField) {
      inputField.addEventListener('wheel', preventScroll, { passive: false })
      return () => {
        inputField.removeEventListener('wheel', preventScroll)
      }
    }
  }, [name])

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={name}
          className={`block mb-2 text-sm font-medium text-[#BA141B] ${labelClass}`}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <div className="relative w-full">
        {StartIcon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500">
            {StartIcon}
          </div>
        )}

        <input
          ref={Ref}
          id={name}
          type={type || 'text'}
          autoFocus={autoFocus}
          placeholder={placeholder || ''}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          {...props}
          className={`
            block w-full
            px-4 py-2.5
            text-sm
            text-gray-900
            bg-gray-50 border border-[#BA141B]
            rounded-lg
            shadow-sm
            outline-none
            transition-all duration-150

            ${readOnly
              ? 'bg-gray-100 cursor-not-allowed text-gray-600'
              : `
                focus:bg-white
                focus:border-[#BA141B]
                focus:ring-2
                focus:ring-[#BA141B]/30
                focus:ring-offset-1
              `
            }

            ${StartIcon ? 'pl-10' : ''}
            ${EndIcon ? 'pr-10' : ''}

            ${inputClass}
          `}
        />

        {EndIcon && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-500">
            {EndIcon}
          </div>
        )}
      </div>

      {name && (
        <ErrorMessage
          name={name}
          component="div"
          className="text-xs text-red-600 font-light mt-1.5 ml-1"
        />
      )}
    </div>
  )
}

export default InputFieldOutlined